import * as Sentry from '@sentry/react';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { createRouterErrorHandler } from '@ludolio/shared-ui';
import { routeTree } from './routeTree.gen';

const router = createRouter({
  routeTree,
  defaultOnCatch: createRouterErrorHandler(Sentry.captureReactException),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function App() {
  return <RouterProvider router={router} />;
}

export default App;
